"use client";

import { useConsentManagementVisibility } from "@aleksundshantu/aunds-cookie-plugin-react";
import { useGlobalContext } from "@aleksundshantu/aunds-utils-react/contexts";

type ConsentManagementButtonProps = {
  index: number;
  title: string;
};
export const ConsentManagementButton = ({
  index,
  title,
}: ConsentManagementButtonProps) => {
  const { show: showConsentManagement } = useConsentManagementVisibility();
  const { getLabel } = useGlobalContext();

  return (
    <button
      role="menuitem"
      key={"footer-menu-link-" + index}
      className="footer-link button-reset"
      onClick={showConsentManagement}
      id={`menuitem-${index}`}
      aria-label={getLabel(
        "aria_footer_cookie_setting",
        "öffnet das Cookie-Management-Tool in einem modalen Fenster",
      )}
    >
      {title}
    </button>
  );
};
